import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Card, CardContent } from '@/components/ui/card';
import { ParameterStatusBadge, ParameterStatusDot } from '@/features/ocr/components/ParameterStatusBadge';
import { ParameterData, parameterStatusUtils } from '@/features/ocr/types/ParameterData';
import { Separator } from '@radix-ui/react-select';
interface Props {
  data: ParameterData;
  description: string;
  onInfoClick?: () => void;
}

export const ParameterCard: React.FC<Props> = ({
  data,
  description,
  onInfoClick = () => { },
}) => {
  const { name, value, unit, range, labName, date } = data;
  const extendedName = parameterStatusUtils.getNameForId(name.toUpperCase());

  const {status, outdated} = parameterStatusUtils.calculateStatus(
    value,
    range.min,
    range.max,
    date,
  );

  return (
    <Card className={`${!outdated ? "shadow-md" : "shadow-0 border-none bg-background-light"}`}>
      <CardContent>
        <Accordion type='single' collapsible>
          <AccordionItem value='item-1'>
            <AccordionTrigger className='py-2'>
              <div className='flex justify-between w-full items-center'>
                <div className='flex flex-col gap-2'>
                  <p className='text-lg font-semibold'>
                    {(() => {
                      const displayName = extendedName ?? name;
                      const match = displayName.match(/^(.*?)\s*(\([^)]*\).*)$/);
                      if (match) {
                        const [, main, rest] = match;
                        return (
                          <>
                            {main}{' '}
                            <span className="text-sm font-normal">{rest}</span>
                          </>
                        );
                      }
                      return displayName;
                    })()}
                  </p>
                  <div className='flex gap-4 items-center'>
                    <ParameterStatusBadge
                      value={value}
                      range={range}
                      isSingleStatus
                      date={date}
                    />
                    <div className='flex gap-1 items-center'>
                      <p className='text-xl'>{value}</p>
                      <p className='text-base text-muted'>{unit}</p>
                    </div>
                  </div>
                  <div className='flex gap-3 items-center'>
                    <p className='text-xs font-medium max-w-[100px] truncate md:max-w-[350px]'>{labName}</p>
                    <div>|</div>
                    <div className='flex gap-1 items-center'>
                      <div className='flex items-center'>
                        <p className='text-sm'>{range.min}</p>
                        <p className='text-sm'>-</p>
                        <p className='text-sm'>{range.max}</p>
                      </div>
                      <p className='text-sm'>{unit}</p>
                    </div>
                  </div>
                </div>
                <ParameterStatusDot value={value} range={range} date={date} />
              </div>
            </AccordionTrigger>
            <AccordionContent className='pb-0'>
              <Separator className='w-full h-[1px] bg-gray-200 my-2' />
              <p className='text-sm'>{description}</p>
              {onInfoClick && (
                <p
                  className='mt-2 font-bold text-[12px] text-primary cursor-pointer'
                  onClick={onInfoClick}
                >
                  Nozioni generali
                </p>
              )}
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </CardContent>
    </Card>
  );
};
